import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Header from '../../Components/Dashboard/Header/Header';
import Scenarios from '../../Components/Dashboard/Admin/Scenarios/List';

export default function ScenariossPage() {
  return (
    <>
      <Header />
      <div className="body">
              <Scenarios />
            </div>
    </>
  );
}


// import Scenarios from '../../Components/Dashboard/Admin/Scenarios/Settings';
// import EditScenario from '../../Components/Dashboard/Admin/Scenarios/Scenarios/Update';

// export default function ScenariosPage() {
//   return (
//     <>
//       <Header />

//       <div className="body">
//         <Switch>
//           <Route exact path='/admin/scenarios'>
//             <div className="reporting__settings">
//               <Scenarios />
//             </div>
//           </Route>

//           <Route exact path='/admin/scenarios/scenario/:id'>
//             <div className="reporting__settings">
//               <EditScenario />
//             </div>
//           </Route>

//         </Switch>
//       </div>
//     </>
//   );
// }
